<template>
  <main>
    <!-- Campaign general info section -->
    <CampaignInfoSection :parCampaignId="this.$route.params.id" :parPageRights="pageRights" />

    <!-- Discounts info section -->
    <section class="whiteBox">
      <div class="content">
        <div class="row spaceBetween" v-if="pageRights.manageDiscount">
          <p class="accentuate">{{$t('campaigns.associatedGroupsAndDiscountsSection')}}</p>
          <button
            class="outline"
            @click="addDiscountToGroupOfDiscount(groupsOfDiscounts[0])"
          >{{$t('button.associateDiscount')}}</button>
        </div>
        <div class="row">
          <table>
            <thead>
              <tr>
                <th class="accentuate">{{$t('groupOfDiscountsSection.groupName')}}</th>
                <th class="accentuate">{{$t('products.productName')}}</th>
                <th class="accentuate">{{$t('salesChannel.salesChannel')}}</th>
                <th class="accentuate">{{$t('campaigns.discount')}}</th>
                <th class="accentuate">{{$t('campaigns.use')}}</th>
                <th></th>
                <!--etat-->
                <th></th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <template v-for="localGroupOfDiscounts in groupsOfDiscounts">
                <tr
                  v-for="(localDiscounts, index) in localGroupOfDiscounts['discounts-list']"
                  :key="localDiscounts.id"
                >
                  <td v-if="index==0">
                    {{localGroupOfDiscounts['name']}}
                    <span
                      class="chip grey"
                      v-if="localGroupOfDiscounts['archived']"
                    >{{$t('groupOfDiscountsStatus.archived')}}</span>
                  </td>
                  <td v-else></td>
                  <td>{{localDiscounts['product-name']}}</td>
                  <td>{{localDiscounts['sales-channel-name']}}</td>
                  <td v-if="localDiscounts['discount-value']==0" nowrap>
                    <p class="chipValue void">{{$t('discountValue.noDiscount')}}</p>
                  </td>
                  <td
                    v-else-if="localDiscounts['discount-type']==0 && localDiscounts['discount-value']==100"
                    nowrap
                  >
                    <p class="chipValue red">{{$t('discountValue.free')}}</p>
                  </td>
                  <td v-else nowrap>
                    <p
                      class="chipValue lightorange"
                      v-if="localDiscounts['discount-type'] === 1"
                    >-{{(localDiscounts['discount-value']/100).toFixed(2)}}{{convertCurrencyToSymbol(localDiscounts['discount-currency'])}}</p>
                    <p
                      class="chipValue orange"
                      v-if="localDiscounts['discount-type'] === 0"
                    >-{{localDiscounts['discount-value']}}%</p>
                  </td>
                  <td class="alignRight2">
                    {{localDiscounts['number-of-used-coupons']}}
                    &nbsp; &nbsp;
                    <button>{{$t('button.details')}}</button>
                  </td>
                  <td>
                    <span
                      class="comments"
                      v-if="localDiscounts['archived']"
                    >{{$t('discounts.discountArchived')}}&nbsp;</span>
                    <span
                      class="comments"
                      v-if="localDiscounts['product-archived']"
                    >{{$t('discounts.productArchived')}}&nbsp;</span>
                    <span
                      class="comments"
                      v-if="localDiscounts['sales-channel-archived']||localDiscounts['sales-channel-api-key-status']!=0"
                    >{{$t('discounts.channelArchived')+ ' ('+localDiscounts['sales-channel-name']+')'}}&nbsp;</span>
                  </td>
                  <td>
                    <span
                      class="chip grey"
                      v-if="localDiscounts['sales-channel-archived']||localDiscounts['product-archived']||localDiscounts['archived']||localDiscounts['sales-channel-api-key-status']!=0"
                    >{{$t('discounts.isArchived')}}</span>
                  </td>
                  <td class="bubbleParent" v-if="pageRights.manageDiscount">
                    <button
                      ref="bubble"
                      class="outline"
                      @click="bubbleClick('discount'+localDiscounts.id)"
                    >
                      <img
                        ref="bubble"
                        class="pastille"
                        src="@/assets/images/pastille.png"
                        alt="pastille"
                      />
                    </button>
                    <div class="bubble" v-if="bubbleAction('discount'+localDiscounts.id)">
                      <a
                        @click="modifyDiscountToGroupOfDiscount(localDiscounts)"
                      >{{$t('discounts.modify')}}</a>
                      <a
                        v-if="!localDiscounts['archived']"
                        class="redText"
                        @click="archiveDiscount(localDiscounts)"
                      >{{$t('discounts.archive')}}</a>
                      <a
                        v-if="localDiscounts['archived']"
                        @click="archiveDiscount(localDiscounts)"
                      >{{$t('discounts.activate')}}</a>
                    </div>
                  </td>
                </tr>
                <tr class="totalTrGrey" :key="localGroupOfDiscounts.id">
                  <td>{{$t('groupOfDiscountsSection.total')}}</td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td class="alignRight2">
                    {{localGroupOfDiscounts['number-of-used-coupons']+'/'+localGroupOfDiscounts['max-number-of-uses']}}
                    &nbsp; &nbsp;
                    <button>{{$t('button.details')}}</button>
                  </td>
                  <td></td>
                  <td></td>

                  <td class="bubbleParent" v-if="pageRights.manageDiscount">
                    <button
                      ref="bubble"
                      class="outline"
                      @click="bubbleClick('GroupOfDiscounts'+localGroupOfDiscounts.id)"
                    >
                      <img
                        ref="bubble"
                        class="pastille"
                        src="@/assets/images/pastille.png"
                        alt="pastille"
                      />
                    </button>
                    <div
                      class="bubble"
                      v-if="bubbleAction('GroupOfDiscounts'+localGroupOfDiscounts.id)"
                    >
                      <!-- <a @click="modifyDiscountToGroupOfDiscount(localGroupOfDiscounts)">{{$t('groupOfDiscountsSection.modifyGroupOfDiscountsAction')}}</a>-->
                      <a
                        @click="addDiscountToGroupOfDiscount(localGroupOfDiscounts)"
                      >{{$t('groupOfDiscountsSection.addDiscountAction')}}</a>
                      <a
                        v-if="!localGroupOfDiscounts['archived']"
                        class="redText"
                        @click="archiveGroupOfDiscounts(localGroupOfDiscounts)"
                      >{{$t('groupOfDiscountsSection.archiveAction')}}</a>
                      <a
                        v-if="localGroupOfDiscounts['archived']"
                        @click="archiveGroupOfDiscounts(localGroupOfDiscounts)"
                      >{{$t('groupOfDiscountsSection.activateAction')}}</a>
                    </div>
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
      </div>
    </section>
    <!-- Coupon uses Section -->
    <CouponHistorySection
      v-if="this.pageRights.displayCouponHistory"
      :parCampaignId="this.$route.params.id"
    ></CouponHistorySection>

    <!-- Users Section -->
    <UserSection
      :parUserPageRights="this.pageRights.manageCampaignUser"
      :parCampaignId="this.$route.params.id"
    ></UserSection>

    <!-- Log Section -->
    <section class="whiteBox" v-if="pageRights.logCampaign">
      <div class="content">
        <p class="accentuate">{{$t('campaigns.logsSection')}}</p>
        <br />
        <table>
          <thead>
            <tr>
              <th>{{$t('dateManagement.date')}}</th>
              <th>{{$t('campaigns.logDetails')}}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td></td>
              <td></td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>

    <!-- over the page displays 
    ------------------------------->

    <!-- manage/modifiy discount -->
    <ManageDiscount
      v-if="displayDiscountManagement"
      :parMethod="this.discountMethod"
      :parDiscount="this.curDiscount"
      :parGroupOfDiscounts="this.groupOfDiscounts"
      @close="displayDiscountManagement = false"
      @operationondiscountdone="manageDiscountWithParams"
    ></ManageDiscount>
    <ConfirmationBox
      v-if="show.confirm"
      :parData="confirmationData"
      @continueprocess="continueProcess"
      @close="show.confirm=false"
    ></ConfirmationBox>
  </main>
</template>

<script>
import Campaigns from "@/services/Campaigns";
import GroupsOfDiscounts from "@/services/GroupsOfDiscounts";
import Discounts from "@/services/Discounts";
import bubble from "@/mixins/bubble";
import ManageDiscount from "@/components/discounts/ManageDiscount";
import CampaignInfoSection from "@/components/campaigns/manageCampaign/CampaignInfoSection.vue";
import getCampaignDetails from "@/mixins/getCampaignDetails";
import generalMethods from "@/mixins/generalMethods";
import Coupons from "@/services/Coupons";
import UserSection from "@/components/campaigns/campaignDetails/UsersSection";
import CouponHistorySection from "@/components/campaigns/campaignDetails/CouponHistorySection";
import ConfirmationBox from "@/mixins/ConfirmationBox";
export default {
  mixins: [bubble, getCampaignDetails, generalMethods],
  components: {
    ManageDiscount,
    UserSection,
    CouponHistorySection,
    ConfirmationBox,
    CampaignInfoSection
  },
  mounted() {
    this.getDiscountsByCampaignId(this.$route.params.id);
    this.checkUserRights();
    //  this.getCampaignInfoById(this.$route.params.id);
  },
  created() {
    document.addEventListener("click", this.manageMenu);
  },
  destroyed() {
    document.removeEventListener("click", this.manageMenu);
  },
  data() {
    return {
      couponTable: [],
      displayAssignCoupon: false
    };
  },
  methods: {
    archiveGroupOfDiscounts(data) {
      GroupsOfDiscounts.partialUpdate(data.id, {
        archived: !data.archived
      }).then(res => {
        if (res.status == 204) {
          data.archived = !data.archived;
        }
      });
    },
    updateCouponHistory() {},
    exportCouponsCodeCSV() {
      //Get coupons
      this.couponTable = [];
      Coupons.getByCampaignId(this.$route.params.id).then(res => {
        if (res.status == 200) {
          this.couponTable = res.data;
          //create csv
          var csv = "Coupon,Groupe\n";
          this.couponTable.forEach(row => {
            csv += row.value;
            csv += ",";
            csv += row["group-of-discounts-name"];
            csv += "\n";
          });
          var hiddenElement = document.createElement("a");
          hiddenElement.href = "data:text/csv;charset=utf-8," + encodeURI(csv);
          hiddenElement.target = "_blank";
          hiddenElement.download =
            "campaign-" + this.campaign.name + "-codescoupon.csv";
          hiddenElement.click();
        }
      });
    },
    getCampaignInfoById(id) {
      if (id) {
        Campaigns.getById(id).then(res => {
          if (res.data["number-of-used-coupons"] == null)
            res.data["number-of-used-coupons"] = "0";
          else
            res.data["number-of-used-coupons"] = res.data[
              "number-of-used-coupons"
            ].toLocaleString("fr");

          if (res.data["max-number-of-coupons"] == null)
            res.data["max-number-of-coupons"] = "0";
          else
            res.data["max-number-of-coupons"] = res.data[
              "max-number-of-coupons"
            ].toLocaleString("fr");
          this.campaign = res.data;
          this.getDiscountsByCampaignId(id);
          this.checkUserRights();
        });
      }
    },
    getDiscountsByCampaignId(campaignId) {
      GroupsOfDiscounts.get(campaignId).then(resGoD => {
        if (resGoD.status == 200) {
          Discounts.getByCampaignId(campaignId).then(resD => {
            this.discountsList = resD.data;
            for (var i = 0; i < resGoD.data.length; i++) {
              resGoD.data[i]["discounts-list"] = resD.data.filter(
                x => x["group-of-discounts-id"] == resGoD.data[i]["id"]
              );
            }
            this.groupsOfDiscounts = resGoD.data;
            this.discount = resD.data;
          });
        }
      });
    },
    modifyDiscountToGroupOfDiscount(currentdiscount) {
      this.discountMethod = "modify_discount";
      this.curDiscount = currentdiscount;
      this.displayDiscountManagement = true;
    }
  }
};
</script>
<style scoped>
</style>